import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PinPad } from "./PinPad";

interface PinDialogProps {
  open: boolean;
  title?: string;
  description?: string;
  onCancel: () => void;
  onSubmit: (pin: string) => void;
  pending?: boolean;
}

export const PinDialog = ({
  open,
  title = "Enter your PIN",
  description = "Confirm with your 4-digit wallet PIN.",
  onCancel,
  onSubmit,
  pending,
}: PinDialogProps) => {
  const [pin, setPin] = useState("");

  useEffect(() => {
    if (!open) setPin("");
  }, [open]);

  useEffect(() => {
    if (pin.length === 4 && !pending) {
      onSubmit(pin);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pin]);

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display">{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <PinPad value={pin} onChange={setPin} disabled={pending} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
